__webpack_require__.p = "/zyklus2/minus/";